
import { Vue, Component, Prop } from "vue-property-decorator";

import DocumentProvider from "@/components/documents/DocumentProvider.vue";
import { Document, User } from "@/generated/graphql";

import ConfirmRemovingDocumentModal from "@/components/documents/ConfirmRemovingDocumentModal.vue";
import Processing from "@/components/common/Processing.vue";

import SearchableListConfig from "@/entities/SearchableListConfig";
import searchableListConfig from "@/data/searchableListConfig";

@Component({
  components: {
    DocumentProvider,
    Processing,
    ConfirmRemovingDocumentModal
  },
  // apollo: {
  //     update(data) {
  //       this.searchableListConfig.total = data.total.aggregate.count;
  //       this.searchableListConfig.loadedCount = data.document.length;
  //       return data.document;
  //     },
  //   },
})
export default class DocumentTable extends Vue {
  @Prop({ type: Object, required: true }) readonly documents!: Document[];
  @Prop({ type: Boolean, default: false }) readonly frozen!: boolean;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Boolean, default: false }) readonly extraInfoHidden!: boolean;
  @Prop({ type: String, default: undefined }) readonly customRequestId?: string;

  searchableListConfig: SearchableListConfig = { ...searchableListConfig };

  removeDocument(remove: Function) {
    if (this.frozen) {
      return;
    }
    remove();
  }

  isFrozen(document: Document): boolean {
    if (this.frozen) {
      return true;
    }

    if (this.currentUser.role === "ADMIN") {
      return false;
    }

    if (this.customRequestId) {
      return false;
    }

    return this.currentUser.id !== document.uploaded_by;
  }
  formatDate(dateToBeFormatted) {
        const date = new Date(dateToBeFormatted);
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    }
    getDocumentSize(size){
    size = (Number(size) / 1024).toFixed(1).replace(".0", "");

    return `${size} kB`;
  }
  // async updateDocumentList(): Promise<void>{
  //     this.$emit("listChanged");
  //     await this.$apollo.queries.documents.refetch();
  //     this.$emit("documentNumberChanged", this.searchableListConfig.total)
  //   }
}
